export function SimularIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2346 9.36567C13.2166 8.82463 13.0746 8.28358 12.8081 7.79851L10.4621 3.52612C10.2844 3.20896 10.16 2.85448 10.0889 2.5L9.98223 2.68657C9.39573 3.75 9.39573 5.03731 9.98223 6.10075L11.8661 9.51493C12.4526 10.5784 12.4526 11.8657 11.8661 12.9291L11.7595 13.1157C11.6884 12.7612 11.564 12.4067 11.3863 12.0896L9.66232 8.95522L8.5782 6.95896C8.40047 6.64179 8.27607 6.28731 8.20498 5.93284L8.09834 6.1194C7.51185 7.16418 7.51185 8.47015 8.09834 9.51493L10 12.9291C10.5865 13.9925 10.5865 15.2799 10 16.3433L9.89336 16.5299C9.82227 16.1754 9.69787 15.8209 9.52014 15.5037L7.17417 11.2313C6.85427 10.653 6.71209 10.0187 6.74763 9.38433C4.24171 10.0746 2.5 11.5299 2.5 13.2276C2.5 15.5784 5.859 17.5 10 17.5C14.141 17.5 17.5 15.597 17.5 13.2276C17.482 11.5112 15.7583 10.056 13.2346 9.36567Z"
        fill="#E22446"
      />
    </svg>
  );
}
